<script>
  	import { Match, Matcher } from 'svelte-store-router'
  	import { Authentication, route } from './stores.js'
	import Cheese from "./components/Cheese.svelte";
	import Orders from "./components/Orders.svelte";
	import Customers from "./components/Customers.svelte";
	import BaseData from "./components/BaseData.svelte";
	import Menu from "./components/Menu.svelte";
	import Login from "./components/Login.svelte";
  	import { onMount } from "svelte"

	let savestore = false

	$: if (savestore && $Authentication) {
	window.sessionStorage.setItem("Authentication", JSON.stringify($Authentication))
	}

	onMount(async () => {
	let ses = window.sessionStorage.getItem("Authentication")
		if (ses) {
			$Authentication = JSON.parse(ses)
		}
	savestore = true
	})
</script>

<main>
	<Menu/>
	
	<div class="box">
		{#if $Authentication}
		<Matcher>
			<Match route={$route} pattern="/login">
				<Login/>
			</Match>
			<Match route={$route} pattern="/orders">
				<Orders/>
			</Match>
			<Match route={$route} pattern="/customers">
				<Customers/>
			</Match>
			<Match route={$route} pattern="/basedata">
				<BaseData/>
			</Match>
			<Match route={$route} pattern="/users/:id" let:params={{ id }}>
			User {id} profile
			</Match>
			<Match route={$route}>
				<Cheese/>
			</Match>
		</Matcher>
		{/if}
		{#if !$Authentication}
		<Login/>
		{/if}
	</div>
</main>

<style>
	.box {
	  background: rgb(231, 224, 163);
	  padding: 3rem 10%;
	  border-radius: 0.8rem;
	  display: flex;
	  flex-direction: column;
	}
</style>